var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgi2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1667 13.5L24.0833 3L6 13.5V34.5L24.0833 45L42.1667 34.5V13.5ZM40.1615 14.6667L24.0875 5.33333L8.01338 14.6667V33.3333L24.0875 42.6667L40.1615 33.3333V14.6667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1296 15.8366L24.0648 7.66992L10 15.8366V32.1699L24.0648 40.3366L38.1296 32.1699V15.8366ZM28.903 16.3154L22.024 13.0039L19.4804 14.5979V33.8263L22.024 35.4203L28.903 32.1088V16.3154ZM20.7359 14.7287L21.6599 14.1496V15.0825L20.7359 14.7287ZM20.2579 15.3782L21.6599 15.915V32.5087L20.2579 33.0459V15.3782ZM22.4373 16.2127V32.2108L25.9115 30.8796V17.5429L22.4373 16.2127ZM20.7357 33.6954L21.6599 33.3413V34.2747L20.7357 33.6954ZM22.4373 33.0434V34.3585L27.4714 31.9351L26.3111 31.5591L22.4373 33.0434ZM26.689 30.8643L28.1256 31.3299V17.0939L26.689 17.5583V30.8643ZM26.3111 16.8634L27.4704 16.4887L22.4373 14.0658V15.3802L26.3111 16.8634Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgi2);
export default __webpack_public_path__ + "static/media/agi2.76effaf314d7d5a4cd52760b20b7364f.svg";
export { ForwardRef as ReactComponent };